import axios from 'axios'

export const OTHER_INCOME_GET = 'OTHER_INCOME_GET'
export const OTHER_INCOME_UPDATE = 'OTHER_INCOME_UPDATE'
export const OTHER_INCOME_SAVING = 'OTHER_INCOME_SAVING'
export const OTHER_INCOME_SAVE = 'OTHER_INCOME_SAVE'
export const OTHER_INCOME_SAVE_SUCCESS = 'OTHER_INCOME_SAVE_SUCCESS'
export const OTHER_INCOME_SAVE_ERROR = 'OTHER_INCOME_SAVE_ERROR'

export const getOtherIncome = (taxReturnId) => (dispatch) => {
    axios
        .get(`/otherincomes/${taxReturnId}`)
        .then((response) => {
            const otherIncome = { ...response.data, fetchSuccessful: true }

            dispatch(updateOtherIncome(otherIncome))
        })
        .catch((errorResponse) => {
            if (errorResponse.status === 404) {
                dispatch(updateOtherIncome({ fetchSuccessful: true }))
            }
        })
}

export const updateOtherIncome = (otherIncome) => ({
    type: OTHER_INCOME_UPDATE,
    otherIncome,
})

export const otherIncomeSaving = (otherIncome) => ({
    type: OTHER_INCOME_SAVING,
    otherIncome,
})

export const saveOtherIncome = () => (dispatch, getState) => {
    const { taxReturn, otherIncome } = getState()

    dispatch(otherIncomeSaving, otherIncome)

    axios
        .put(`/otherincomes/${taxReturn.id}`, { ...otherIncome, taxReturnId: taxReturn.id })
        .then((response) => {
            dispatch(otherIncomeSaveSuccess({ ...response.data }))
        })
        .catch((errorResponse) => {
            const existingOtherIncome = { ...otherIncome }
            dispatch(otherIncomeSaveError(existingOtherIncome, errorResponse.data))
        })
}

export const otherIncomeSaveSuccess = (otherIncome) => ({
    type: OTHER_INCOME_SAVE_SUCCESS,
    otherIncome,
})

export const otherIncomeSaveError = (otherIncome, errorResponse) => ({
    type: OTHER_INCOME_SAVE_ERROR,
    otherIncome,
    errorResponse,
})

export const updateAndSaveOtherIncome = (otherIncome) => (dispatch) => {
    dispatch(updateOtherIncome(otherIncome))
    dispatch(saveOtherIncome())
}
